import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "detail-container" }
const _hoisted_3 = { class: "swipe-list" }
const _hoisted_4 = { class: "food-info" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "price" }
const _hoisted_7 = {
  key: 0,
  class: "rate"
}
const _hoisted_8 = {
  key: 1,
  class: "sales-info"
}
const _hoisted_9 = { class: "price" }
const _hoisted_10 = { class: "quantity" }
const _hoisted_11 = { class: "food-option" }
const _hoisted_12 = { class: "spec" }
const _hoisted_13 = { class: "option-list" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 0,
  class: "cooking"
}
const _hoisted_16 = { class: "option-list" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "num" }
const _hoisted_19 = { class: "" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = {
  key: 1,
  class: "recommend"
}
const _hoisted_22 = { class: "recommend-list-scroll" }
const _hoisted_23 = { class: "recommend-info" }
const _hoisted_24 = { class: "food-name" }
const _hoisted_25 = { class: "food-price" }
const _hoisted_26 = { class: "bottom border-top" }
const _hoisted_27 = { class: "button" }
const _hoisted_28 = { class: "dialog-content" }

import { computed, onMounted, ref } from 'vue';
  import h5Config from '@/config/config';
  import router from '@/router';
  import { getCommodity } from '@/service/commodity';
  import { useRoute } from 'vue-router';
  import { CommodityModel } from '@/model/commdoity';
  import { fetchAddCart, fetchCartList } from '@/service/order';
  import useMainStore from '@/store/useMainStore';
  import { showDialog } from 'vant';
  import { CartModel } from '@/model/order';
  import { showImagePreview } from 'vant';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'DetailView',
  setup(__props) {

_useCssVars(_ctx => ({
  "066f72cc": (_unref(h5Config).themeColor)
}))

  const route = useRoute();
  const mainStore = useMainStore();
  const shopId = mainStore.getShopId;
  const customerId = mainStore.getcustomerId;
  const customerName = mainStore.getcustomerName;
  const foodId = ref(0);
  const quantity = ref(1);
  const detailModel = ref<CommodityModel>({});
  const images = ref<string[]>([]);
  const showTableDialog = ref(false);

  const getPrice = computed(() => detailModel.value.specList?.find((item) => item.checked)?.price);
  const getFoodCookDesc = computed(() => {
    let foodCookDesc = '';
    detailModel.value.cookList?.forEach((item) => {
      const list = item.valueList?.filter((info) => info.checked).map((info) => info.value) || [];
      if (list.length) {
        foodCookDesc += `${item.cookName}：${list.join('、')} | `;
      }
    });

    if (foodCookDesc?.endsWith(' | ')) {
      foodCookDesc = foodCookDesc.slice(0, -3);
    }
    return foodCookDesc;
  });

  const getDescription = computed(() =>
    detailModel.value.description
      ?.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
      ?.replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, ''),
  );

  onMounted(() => {
    foodId.value = Number(route.query.id);
    loadCommodity();
    loadCartData();
  });

  const loadCommodity = async () => {
    const res = await getCommodity({ shopFoodId: foodId.value, shopFoodStatus: 0 });
    detailModel.value = res.result || {};
    if (detailModel.value.specList?.length) {
      detailModel.value.specList.forEach((item, index) => {
        item.checked = index === 0;
      });
    }
    if (detailModel.value.cookList?.length) {
      detailModel.value.cookList?.forEach((item) => {
        item.valueList?.forEach((info) => {
          info.checked = false;
        });
      });
    }

    images.value = [detailModel.value.imageUrl || ''];

    // if (detailModel.value.foodName === '红烧狮子头') {
    //   detailModel.value.description = `
    //   <h2>菜品详情</h2>
    //   <p>
    //     红烧狮子头是一道经典的中式传统名菜，属于淮扬菜系。选用上等五花肉和新鲜猪肉馅，精心调配而成。肉质鲜嫩多汁，咸鲜适口，香味浓郁，入口即化，风味独特。
    //   </p>
    //   <h2>主要材料</h2>
    //   <p>猪肉、葱姜蒜、酱油、料酒、白糖</p>
    //   <h2>过敏原</h2>
    //   <p>大豆</p>`;
    // }
  };

  const cartList = ref<Array<CartModel>>([]);
  const cartCount = computed(() => {
    return cartList.value.reduce((sum, item) => sum + (item.count || 0), 0);
  });
  const loadCartData = async () => {
    const resp = await fetchCartList({
      pageNum: 1,
      pageSize: 999,
      data: { cartTag: mainStore.getCarTag() },
    });
    if (resp.code !== 200) {
      showDialog({ message: resp.msg });
    } else {
      cartList.value = [];
      resp.result.list.forEach((item: any) => {
        cartList.value.push({
          shopCartId: item.shopCartId,
          id: item.shopFoodId,
          count: item.quantity,
          price: item.price,
        });
      });
    }
  };

  // 热门菜品数据
  const recommendList = ref([
    {
      name: '北京烤鸭',
      price: 88,
      imgUrl:
        'https://images.unsplash.com/photo-1512058564366-18510be2db19?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=60',
    },
    {
      name: '水煮鱼',
      price: 68,
      imgUrl:
        'https://images.unsplash.com/photo-1563245372-f21724e3856d?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=60',
    },
    {
      name: '宫保鸡丁',
      price: 52,
      imgUrl:
        'https://images.unsplash.com/photo-1534422298391-e4f8c172dddb?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=60',
    },
  ]);

  const handleSpecChange = (index: number) => {
    detailModel.value.specList?.forEach((item, i) => {
      item.checked = i === index;
    });
  };

  const handleSelectedCook = (cookIndex: number, selectedIndex: number) => {
    const cookItem = detailModel.value.cookList?.at(cookIndex);
    if (!cookItem) return;

    if (cookItem.cookType === 1) {
      detailModel.value.cookList?.at(cookIndex)?.valueList?.forEach((item, i) => {
        if (i === selectedIndex) {
          item.checked = !item.checked;
          return;
        }
      });
    } else if (cookItem.cookType === 2) {
      detailModel.value.cookList?.at(cookIndex)?.valueList?.forEach((item, i) => {
        item.checked = i === selectedIndex;
      });
    }
  };

  const onClickLeft = () => {
    router.back();
  };

  const handleGoToCart = () => {
    router.push('/cart');
  };

  const handleAddToCart = async () => {
    if (!mainStore.getShopId || !mainStore.getTableId || !mainStore.getQrCode) {
      showTableDialog.value = true;
      return;
    }
    showTableDialog.value = false;

    const specItem = detailModel.value.specList?.find((item) => item.checked);

    const resp = await fetchAddCart({
      shopId: shopId,
      tableId: mainStore.getTableId,
      cartTag: mainStore.getCarTag(),
      customerId: customerId,
      customerName: customerName,
      shopFoodId: detailModel.value.shopFoodId,
      shopFoodName: detailModel.value.shopFoodName,
      foodId: detailModel.value.foodId,
      foodName: detailModel.value.foodName,
      foodType: detailModel.value.foodType,
      shopFoodSpecId: specItem?.shopFoodSpecId,
      foodSpecName: specItem?.specName,
      foodCookDesc: getFoodCookDesc.value,
      quantity: 1,
      price: getPrice.value,
    });

    if (resp.code === 200) {
      router.push('/cart');
    } else {
      showDialog({ message: resp.msg });
      return;
    }
  };

  const handleImageClick = (index: number) => {
    // currentBigImage.value = imgSrc;
    // showImagePopup.value = true;

    showImagePreview({
      images: images.value,
      startPosition: index,
      closeable: true,
    });
  };

  const handleScanClose = () => {
    showTableDialog.value = false;
  };

  const handleGoScanQRCode = () => {
    router.replace('/scan');
  };

  const beforeChange = () => {
    if (!mainStore.getShopId || !mainStore.getTableId || !mainStore.getQrCode) {
      showTableDialog.value = true;
      return false;
    }
    showTableDialog.value = false;
    return true;
  };

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!
  const _component_van_rate = _resolveComponent("van-rate")!
  const _component_van_stepper = _resolveComponent("van-stepper")!
  const _component_van_badge = _resolveComponent("van-badge")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_dialog = _resolveComponent("van-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_nav_bar, {
        title: "商品详情",
        border: "",
        fixed: "",
        "left-arrow": "",
        onClickLeft: onClickLeft
      }, {
        left: _withCtx(() => [
          _createVNode(_component_van_icon, {
            name: "arrow-left",
            size: "22",
            color: "#000"
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_van_swipe, {
            autoplay: 3000,
            "stop-propagation": false,
            "indicator-color": "white"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images.value, (image, index) => {
                return (_openBlock(), _createBlock(_component_van_swipe_item, {
                  key: index,
                  onClick: ($event: any) => (handleImageClick(index))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_image, {
                      src: image,
                      fit: "cover",
                      class: "img"
                    }, null, 8, ["src"])
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(detailModel.value.shopFoodName), 1),
          _createElementVNode("div", _hoisted_6, "¥" + _toDisplayString(getPrice.value), 1),
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_van_rate, {
                  modelValue: detailModel.value.rating,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((detailModel.value.rating) = $event)),
                  size: 25,
                  "allow-half": "",
                  color: "#ffd21e",
                  "void-icon": "star",
                  "void-color": "#eee"
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, "¥" + _toDisplayString(getPrice.value), 1),
                _createElementVNode("span", _hoisted_10, "月售" + _toDisplayString(detailModel.value.salesCount) + "份", 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _cache[3] || (_cache[3] = _createElementVNode("h2", null, "规格", -1)),
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailModel.value.specList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(["option", { active: item.checked }]),
                  onClick: ($event: any) => (handleSpecChange(index))
                }, [
                  _createElementVNode("span", null, _toDisplayString(item.specName) + "（¥" + _toDisplayString(item.price) + "）", 1)
                ], 10, _hoisted_14))
              }), 128))
            ])
          ]),
          (detailModel.value.cookList?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailModel.value.cookList, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "cooking-item"
                  }, [
                    _createElementVNode("h2", null, _toDisplayString(item.cookName), 1),
                    _createElementVNode("div", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.valueList, (info, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: idx,
                          class: _normalizeClass(["option", { active: info.checked }]),
                          onClick: ($event: any) => (handleSelectedCook(index, idx))
                        }, [
                          _createElementVNode("span", null, _toDisplayString(info.value), 1)
                        ], 10, _hoisted_17))
                      }), 128))
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_18, [
            _cache[4] || (_cache[4] = _createElementVNode("h2", null, "数量", -1)),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_van_stepper, {
                modelValue: quantity.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((quantity).value = $event)),
                theme: "round",
                "button-size": "30",
                "disable-input": "",
                "before-change": beforeChange
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        (getDescription.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "food-desc",
              innerHTML: getDescription.value
            }, null, 8, _hoisted_20))
          : _createCommentVNode("", true),
        false
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _cache[5] || (_cache[5] = _createElementVNode("h2", null, "猜你喜欢", -1)),
              _createElementVNode("div", _hoisted_22, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recommendList.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "recommend-item"
                  }, [
                    _createVNode(_component_van_image, {
                      src: item.imgUrl,
                      radius: "10px",
                      class: "recommend-img"
                    }, null, 8, ["src"]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("h3", _hoisted_24, _toDisplayString(item.name), 1),
                      _createElementVNode("p", _hoisted_25, "￥" + _toDisplayString(item.price), 1)
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", {
          class: "cart",
          onClick: handleGoToCart
        }, [
          _createVNode(_component_van_badge, { content: cartCount.value }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createElementVNode("i", { class: "fas fa-shopping-cart text-2xl text-gray-600" }, null, -1)
            ])),
            _: 1,
            __: [6]
          }, 8, ["content"])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("button", {
            class: "ios-button",
            onClick: handleAddToCart
          }, " 加入购物车 ¥" + _toDisplayString(getPrice.value), 1)
        ])
      ])
    ]),
    _createVNode(_component_van_dialog, {
      show: showTableDialog.value,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((showTableDialog).value = $event)),
      "show-confirm-button": false,
      "destroy-on-close": true,
      class: "spec-dialog"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_component_van_icon, {
            name: "close",
            class: "close-icon",
            onClick: handleScanClose
          }),
          _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "dialog-title" }, "提示", -1)),
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "spec-tags" }, " 请先扫桌号，然后进行点餐。 ", -1)),
          _createVNode(_component_van_button, {
            round: "",
            block: "",
            color: "#dc750e",
            class: "confirm-btn",
            onClick: handleGoScanQRCode
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createElementVNode("span", { style: {"font-weight":"bold","color":"white"} }, "去扫码", -1)
            ])),
            _: 1,
            __: [7]
          })
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})